export enum TodoStatus {
  all = 'All',
  active = 'Active',
  completed = 'Completed',
}
